/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './Home.css';

import Promo from './Promo';
import Header from './Header';
import Features from './Features';
import Education from './Education';
import Footer from './Footer';

class Home extends React.Component {
  state = {
    showPromoBanner: false,
  };

  componentDidMount() {
    let search = window.location.search;
    let params = new URLSearchParams(search);
    let ref = params.get('ref');

    if (ref == "producthunt") {
      this.setState({ showPromoBanner: true })
    }
  }

  render() {
    return (
      <div>
        {this.state.showPromoBanner &&
          <Promo />
        }
        <Header />
        <Features />
        <Education />
        <Footer />
      </div>
    );
  }
}

export default withStyles(s)(Home);
